export default __webpack_public_path__ + "static/media/abierto.85d70689.png";